import React, { useEffect, useState } from 'react'
import { getSosSearchAutoreport, saveSosRecord, requestSosSearch, requestSosSearchDemoMode } from 'actions/applicants'
import AutoreportSearchResultCard from './AutoreportSearchResultCard'
import {useAppContext} from "../../../../../../../../context/AppContext";

const SolveSosSearch = ({ applicationId, requestDecision, creditCosts }) => {

    const [sosSearchAutoreportData, setSosSearchAutoreportData] = useState([])

    const sosSearchAutoreport = sosSearchAutoreportData?.response?.results?.[0]
    const possibleAlternatives = sosSearchAutoreportData?.response?.possibleAlternatives
    const sosSearchId = sosSearchAutoreportData?.sosSearchId
    const state = sosSearchAutoreportData?.state
    const { isDemoMode } = useAppContext()

    useEffect(() => {
        getSosSearchAutoreport(applicationId, isDemoMode)()
            .then((res) => {
                setSosSearchAutoreportData(res)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleSaveSosRecord = (mode, payload) => {
        const requestSosSearchEndpoint = isDemoMode ? requestSosSearchDemoMode : requestSosSearch
        const saveEndpoint = mode === 'closeMatch' ? saveSosRecord : requestSosSearchEndpoint

        if (mode === 'closeMatch') {
            payload.sosSearchId = sosSearchId
        } else {
            payload.state = state
            payload.autoReportRequest = true
        }

        saveEndpoint({ applicationId, payload })()
            .then(() => requestDecision())
    }

    return (
        <div className='mt-3'>
            {
                sosSearchAutoreport &&
                <AutoreportSearchResultCard
                    searchResult={sosSearchAutoreport}
                    possibleAlternatives={possibleAlternatives}
                    saveSosRecord={handleSaveSosRecord}
                    state={state}
                    creditCosts={creditCosts}
                />
            }
        </div>
    )
}

export default SolveSosSearch